import React, { useState } from 'react';
import { Popover, Card, ListGroup, OverlayTrigger, Button as RBButton } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export default function ProjectFieldsPopover(_ref) {
  let {
    selectedProjectFields,
    setSelectedProjectFields
  } = _ref;
  const [isAllSelected, setIsAllSelected] = useState(true);
  const {
    t
  } = useTranslation();
  const selectAllProjectFields = () => {
    if (isAllSelected) {
      setSelectedProjectFields([]);
    } else {
      setSelectedProjectFields(window.MARKET_CONSTANTS.PROJECT_EXPORT_FIELDS_LIST);
    }
    setIsAllSelected(!isAllSelected);
  };
  const selectProjectField = field => {
    if (selectedProjectFields.includes(field)) {
      setSelectedProjectFields(selectedProjectFields.filter(f => f !== field));
    } else {
      setSelectedProjectFields([...selectedProjectFields, field]);
    }
  };
  const projectFieldPopover = /*#__PURE__*/React.createElement(Popover, {
    id: "popover-project-fields",
    className: "project-fields-selector-container"
  }, /*#__PURE__*/React.createElement(Card, {
    className: "p-2 project-fields-selector-card",
    style: {
      maxHeight: '400px',
      overflowY: 'auto'
    }
  }, /*#__PURE__*/React.createElement(ListGroup, {
    defaultActiveKey: 'all'
  }, /*#__PURE__*/React.createElement(ListGroup.Item, {
    className: "project-fields-item mb-1",
    active: isAllSelected,
    key: "all",
    action: true,
    onClick: selectAllProjectFields
  }, "All"), window.MARKET_CONSTANTS.PROJECT_EXPORT_FIELDS_LIST.map(field => /*#__PURE__*/React.createElement(ListGroup.Item, {
    className: "project-fields-item mb-1",
    active: selectedProjectFields.includes(field),
    key: field,
    action: true,
    onClick: () => selectProjectField(field)
  }, t(field))))));
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    trigger: "click",
    rootClose: true,
    overlay: projectFieldPopover
  }, /*#__PURE__*/React.createElement(RBButton, {
    style: {
      width: '240px'
    },
    variant: "primary",
    className: "me-4"
  }, t('project_fields')));
}